import React from 'react';
import { chakra, Icon, Text, Badge } from '@chakra-ui/react';
import { formatMoney } from '@src/utils/function';
import { ReactComponent as CreditCardSvg } from '@src/icons/credit-card.svg';
import DateFormat from '@src/components/atoms/DateFormat';
import { Payment } from './PaymentLineItem';

export default function PaymentItemMobile({
  date,
  details,
  bankStatement,
  id,
  refunded,
}: Payment) {
  const status = refunded ? 'refunded' : 'paid';
  return (
    <chakra.div rounded="xl" shadow="lg" bg="white" w="full" p={5}>
      <chakra.div>
        <chakra.div d="flex" justifyContent="space-between" alignItems="center">
          <Text fontSize="sm" fontWeight="light">
            {bankStatement}{' '}
            <Text as="span" fontSize="xs" color="blue.300" fontWeight="light">
              ID: {id}
            </Text>
          </Text>
        </chakra.div>

        <chakra.div
          d="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={4}
        >
          <Text fontWeight="light" fontSize="sm">
            <DateFormat date={date} />
          </Text>
        </chakra.div>
        <chakra.div
          d="flex"
          justifyContent="space-between"
          mt={4}
          alignItems="center"
        >
          <Text fontWeight="light" fontSize="sm">
            <Icon as={CreditCardSvg} mr={1} w={6} h={6} color="gray.600" />
            {details.paymentSource.cardLast4}
          </Text>
          <Text fontWeight="semibold" fontSize="xs" ml={1}>
            {formatMoney(details.total)}
          </Text>
          <Badge colorScheme={status === 'refunded' ? 'red' : 'green'}>
            {status}
          </Badge>
        </chakra.div>
      </chakra.div>
    </chakra.div>
  );
}
